import React from "react";
import { FaLinkedinIn, FaDev, FaTwitter } from "react-icons/fa";
import { HiOutlineAtSymbol } from "react-icons/hi";
import { H3 } from "../../../styles/Headings.js";
import { P2 } from "../../../styles/Paragraphs.js";
import { Highlight } from "../../../styles/Utilities.js";
import Section from "../../../styles/Section.js";
import Button from "../../../styles/Button.js";
import resume from "../../../docs/resume.pdf";
import {
   Contacts,
   Contact,
   ContactIcon,
   ContactLink
} from "./ContactSectionStyles.js";
import InView from "react-intersection-observer";

const contactVariant = {
   hidden: {
      y: 50,
      opacity: 0,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.3
         },
         opacity: {
            duration: 0.3
         }
      }
   },
   visible: i => ({
      y: 0,
      opacity: 1,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.3,
            delay: i
         },
         opacity: {
            duration: 0.3,
            delay: i
         }
      }
   })
};

function ContactSectionContainer() {
   return (
      <Section id="contact">
         <H3 center>
            <Highlight>Contact</Highlight> Me
         </H3>
         <P2
            center
            style={{ width: "49rem", maxWidth: "100%", margin: "1.2rem auto" }}
         >
            Have a query ? Feel free to contact me through the following links
         </P2>
         <InView threshold={0.25}>
            {({ ref, inView }) => (
               <Contacts ref={ref}>
                  <Contact
                     custom={0}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={contactVariant}
                  >
                     <ContactIcon
                        href="https://www.linkedin.com/in/paras594/"
                        target="_blank"
                     >
                        <FaLinkedinIn />
                     </ContactIcon>
                     <ContactLink
                        href="https://www.linkedin.com/in/paras594/"
                        target="_blank"
                     >
                        linkedin.com/in/paras594
                     </ContactLink>
                  </Contact>
                  <Contact
                     custom={0.3}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={contactVariant}
                  >
                     <ContactIcon href="mailto:parasarora594@gmail.com">
                        <HiOutlineAtSymbol />
                     </ContactIcon>
                     <ContactLink href="mailto:parasarora594@gmail.com">
                        parasarora594@gmail.com
                     </ContactLink>
                  </Contact>
                  <Contact
                     custom={0.6}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={contactVariant}
                  >
                     <ContactIcon
                        href="https://dev.to/paras594"
                        target="_blank"
                     >
                        <FaDev />
                     </ContactIcon>
                     <ContactLink
                        href="https://dev.to/paras594"
                        target="_blank"
                     >
                        dev.to/paras594
                     </ContactLink>
                  </Contact>
                  <Contact
                     custom={0.9}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={contactVariant}
                  >
                     <ContactIcon
                        href="https://twitter.com/paras594"
                        target="_blank"
                     >
                        <FaTwitter />
                     </ContactIcon>
                     <ContactLink
                        href="https://twitter.com/paras594"
                        target="_blank"
                     >
                        twitter.com/paras594
                     </ContactLink>
                  </Contact>
               </Contacts>
            )}
         </InView>

         <div style={{ textAlign: "center" }}>
            <Button
               as="a"
               href={resume}
               target="_blank"
               download="paras-mern-dev-resume.pdf"
            >
               Resume
            </Button>
         </div>
      </Section>
   );
}

export default ContactSectionContainer;
